import { render, staticRenderFns } from "./PlpNoResults.vue?vue&type=template&id=04c99b22&"
import script from "./PlpNoResults.vue?vue&type=script&lang=js&"
export * from "./PlpNoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports